import { render, staticRenderFns } from "./page-product-text.vue?vue&type=template&id=a5120506&scoped=true&"
import script from "./page-product-text.vue?vue&type=script&lang=js&"
export * from "./page-product-text.vue?vue&type=script&lang=js&"
import style0 from "./page-product-text.vue?vue&type=style&index=0&id=a5120506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5120506",
  null
  
)

export default component.exports